<template>
  <div class="task-stage-page">
    <!-- The help center article for this kind of task -->
    <section v-if="guide && guide.id" class="v2-field" data-qid="task-panel-guide">
      <header class="v2-field__head">
        <h4><font-awesome-icon icon="info-circle" class="mr-1"/>{{ $t('system.help_center_label') }}</h4>
        <span class="v2-link cursor-pointer" @click="$emit('open-guide')" data-qid="task-panel-guide-open">{{ $t('administration.guide.modal.button') }}</span>
      </header>
      <div class="guide-content-container task-panel-help__text" v-html="showFullGuide ? guide.content.rendered : guide.excerpt.rendered"></div>
      <span class="v2-link cursor-pointer" @click="showFullGuide = !showFullGuide">
        {{ showFullGuide ? $t('system.view_less') : $t('system.view_more') }}
        <font-awesome-icon :icon="showFullGuide ? 'chevron-up' : 'chevron-down'" class="ml-1"/>
      </span>
    </section>

    <!-- The project: its dates and people, and what the project owner wrote to the assignees, with files and links -->
    <section v-if="project && project.id" class="v2-field" data-qid="task-panel-project">
      <header class="v2-field__head">
        <h4><font-awesome-icon icon="calendar-alt" class="mr-1"/>{{ project.title }}</h4>
        <router-link v-if="canOpenProject"
                     :to="{ name: 'projects.view', params: { slug: project.slug }}"
                     class="v2-link"
                     data-qid="task-panel-project-open"
        >{{ $t('tasks.v2.open_project') }}</router-link>
      </header>
      <dl class="task-facts">
        <template v-if="project.end_date">
          <dt>{{ $t('projects.schedule.due_date_label') }}</dt>
          <dd>{{ project.end_date | formatDate('DD MMM YYYY', true) }}</dd>
        </template>
        <template v-if="project.users && project.users.length">
          <dt>{{ $t('projects.create.owners_label') }}</dt>
          <dd>
            <span v-for="user in project.users" :key="'project-user-' + user.id" class="task-facts__user">
              <Avatar :object="user" size="xs"></Avatar>{{ user.name }}
            </span>
          </dd>
        </template>
      </dl>
      <span v-if="welcomeGuide && welcomeGuide.id" class="v2-link cursor-pointer" @click="$emit('open-welcome')">{{ $t('system.welcome_page_button') }}</span>
      <template v-if="project.schedule_message">
        <div class="task-panel-help__label">{{ $t('tasks.modal.project_message_label') }}</div>
        <p class="text-formatted mb-1">{{ showFullMessage || project.schedule_message.length <= 300 ? project.schedule_message : $options.filters.truncate(project.schedule_message, 300) }}</p>
        <span v-if="project.schedule_message.length > 300" class="v2-link cursor-pointer" @click="showFullMessage = !showFullMessage">
          {{ showFullMessage ? $t('system.view_less') : $t('system.view_more') }}
        </span>
      </template>
      <div v-for="file in project.media || []" :key="'project-file-' + file.id" class="task-panel-help__item">
        <font-awesome-icon icon="paperclip" class="mr-1 text-muted"/>
        <a href="#" @click.prevent="$emit('download', file)" qid="create-p-media-item">{{ file.file_name }}</a>
      </div>
      <div v-for="link in project.links || []" :key="'project-link-' + link.id" class="task-panel-help__item">
        <font-awesome-icon icon="link" class="mr-1 text-muted"/>
        <a :href="link.url" target="_blank" rel="noopener" qid="create-p-link-item">{{ link.name ? link.name : link.url }}</a>
      </div>
    </section>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';

// Right-hand column of a task panel (US 9478): the help center article and the project's message to the assignees
export default {
  name: 'TaskPanelHelp',
  components: {
    Avatar
  },
  props: {
    project: { type: Object, default: () => ({}) },
    guide: { type: Object, default: null },
    welcomeGuide: { type: Object, default: null },
    // Only project owners (and admins) can open the project page
    canOpenProject: { type: Boolean, default: false }
  },
  data() {
    return {
      showFullGuide: false,
      showFullMessage: false
    };
  },
}
</script>
